import { kontakt, odpiralniCas } from "@/mocks/lokacija";
import SectionLink from "@/components/base/SectionLink";

const quickLinks = [
  { label: "Domov", hash: "domov" },
  { label: "O nas", hash: "o-nas" },
  { label: "Ponudba", hash: "ponudba" },
  { label: "Galerija", hash: "galerija" },
  { label: "Kontakt", hash: "kontakt" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-secondary-950 text-background-100">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-accent-500/60 to-transparent" />

      <div className="border-b border-background-100/10">
        <div className="section-shell flex flex-col gap-3 py-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="flex items-center gap-2 font-label text-[9px] font-semibold uppercase tracking-[0.2em] text-accent-400">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            Zadružni trg 12D · Ptuj
          </p>
          <p className="font-label text-[9px] uppercase tracking-[0.18em] text-background-100/60">
            Pon–Čet 06–22 · Pet–Sob 06–24 · Ned 07–20
          </p>
        </div>
      </div>

      <div className="section-shell pb-[104px] pt-12 md:py-16 lg:pb-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <img
                src="https://public.readdy.ai/ai/img_res/b6a5fe69-5197-42cf-a97a-adcd094ddbaa.png"
                alt="Logotip Bar Stanka Ptuj"
                className="h-14 w-14 shrink-0 object-contain"
              />
              <div>
                <p className="font-heading text-[18px] font-semibold tracking-[0.24em] text-background-50">
                  BAR STANKA
                </p>
                <p className="mt-1 font-label text-[10px] uppercase tracking-[0.3em] text-accent-400">
                  Ptuj
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-[280px] text-sm leading-relaxed text-background-100/75">
              Prijeten kotiček na Ptuju za jutranjo kavo, kratek oddih in
              sproščeno druženje v toplem, domačem vzdušju.
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <a
                href={kontakt.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Bar Stanka na Facebooku"
                className="inline-flex items-center gap-2.5 rounded-full border border-background-100/25 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-400"
              >
                <i className="ri-facebook-fill text-base" />
                Facebook
              </a>
              <a
                href={kontakt.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Bar Stanka na Instagramu"
                className="inline-flex items-center gap-2.5 rounded-full border border-background-100/25 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-400"
              >
                <i className="ri-instagram-line text-base" />
                Instagram
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-[10px] font-semibold uppercase tracking-[0.22em] text-accent-400">
              <SectionLink hash="kontakt" className="transition-colors hover:text-background-50">
                Naslov
              </SectionLink>
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80">
              Bar Stanka
              <br />
              Zadružni trg 12D
              <br />
              2250 Ptuj, Slovenija
            </p>
            <a
              href={kontakt.googleMaps}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-accent-400 transition-colors hover:text-background-50"
            >
              <i className="ri-map-pin-line text-base" />
              Poglej na zemljevidu
            </a>
          </div>

          <div>
            <h4 className="font-label text-[10px] font-semibold uppercase tracking-[0.22em] text-accent-400">
              <SectionLink hash="kontakt" className="transition-colors hover:text-background-50">
                Odpiralni čas
              </SectionLink>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-100/80">
              {odpiralniCas.map((item) => (
                <li key={item.id} className="flex items-baseline justify-between gap-4">
                  <span>{item.dnevi}</span>
                  <span
                    className={
                      item.ure === "Zaprto"
                        ? "whitespace-nowrap text-[12px] uppercase tracking-[0.06em] text-background-100/55"
                        : "whitespace-nowrap text-background-50"
                    }
                  >
                    {item.ure}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-[10px] font-semibold uppercase tracking-[0.22em] text-accent-400">
              <SectionLink hash="domov" className="transition-colors hover:text-background-50">
                Navigacija
              </SectionLink>
            </h4>
            <ul className="mt-4 space-y-2">
              {quickLinks.map((link) => (
                <li key={link.hash}>
                  <SectionLink
                    hash={link.hash}
                    to={link.hash}
                    className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </SectionLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:mt-12 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
          <p className="text-[12px] text-background-100/60">
            © 2026 Bar Stanka. Vse pravice pridržane.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <p className="text-[12px] text-background-100/50">
              Zadružni trg 12D, 2250 Ptuj
            </p>
            <SectionLink
              hash="domov"
              className="inline-flex items-center gap-2 font-label text-[9px] font-semibold uppercase tracking-[0.16em] text-background-100/70 transition-colors hover:text-accent-400"
            >
              Na vrh
              <i className="ri-arrow-up-line text-[13px]" />
            </SectionLink>
          </div>
        </div>
      </div>
    </footer>
  );
}